import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import { debug } from "../utils";
import { TableContext } from "../index";
import LocalPaginationManager from "../view/LocalPaginationManager";
import * as mailRecipientService from "./mailRecipientService";
import AdditionalRecipientTable from "./AdditionalRecipientTable";
import AdditionalRecipientTableHeader from "./AdditionalRecipientTableHeader";
import { ChevronDown } from "lucide-react";

function AdditionalRecipientTableSection() {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        isLoading: true
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);
    const [collapsed, setCollapsed] = useState(true);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div key={history.location} className="mb-0">
                <div className="card oct_analysis-card-v2 p-0">
                    <button
                        className="oct_settings-section-header w-100 border-0 p-4"
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        <h3>Additional Recipients</h3>
                        <ChevronDown
                            className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
                        />
                    </button>
                    <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                                                    <AdditionalRecipientTableHeader />

                        <div className="card-body">
                            <div className="dataTables_wrapper dt-bootstrap4 no-footer mt-1">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <AdditionalRecipientTable />
                                        <LocalPaginationManager getPage={mailRecipientService.getPaginated} sizeLimit={4} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default AdditionalRecipientTableSection;